import API from './API';


export default {

  addMinute(minute){
    return API.post(`/minute` , minute);
  },  
  
  getCarsByCustomer(customerId, /* partnerId */) {
    return API.get(`/car?filter=customer.id||$eq||${customerId}&` , {
      params: {
       join: 
       [
         'minutes',
         'minutes.partner',
         'customer',
         'headquarters',
         'headquarters.employees'
       ]
       
     },  
   });
  },

  getMinutesByCustomer( customerId, partnerId) {
    return API.get(`/minute?filter=car.customer.id||$eq||${customerId}&filter=partner.id||$eq||${partnerId}&filter=accepted||$eq||${true}&` , {
      params: {
       join: 
       [
        'partner',
         'car',
         'car.customer',
       ],
     },  
   });
  },

  addCar(car){
    return API.post('/car', car)
  },

  modifyCar(car){
    return API.patch('/car/'+car.id, car)
  }
  
};

